import { useTranslation } from 'react-i18n-lite'

import { FilterActionSetup, FilterButton } from '../../FilterFields.styles'

import { useMemo } from 'react'
import { useFilterFieldsContext } from '../../context'
import Fields from '../Fields/Fields'
import FilteractionSelection from '../FilteractionSelection/FilteractionSelection'
import FilterComposition from '../FilterComposition/FilterComposition'
import GroupControls from '../GroupControls/GroupControls'
import {
  useSectionComposition,
  useSectionFilteraction,
  useSectionGroupActions,
  useSectionNavigation
} from './hooks'
import { SectionContextProvider } from './SectionContext'
import SectionView from './SectionView'

const Section = () => {
  const { t } = useTranslation()

  const { config } = useFilterFieldsContext()

  const {
    displayOptionsForElement: displayOptionsElement,
    hideFields,
    enableComposition = false
  } = config

  const shouldRenderComposition =
    enableComposition && !displayOptionsElement?.hideFields

  const shouldRenderFilteractionSelection =
    !displayOptionsElement?.hideFilteraction

  const shouldRenderFields = !displayOptionsElement?.hideFields && !hideFields

  const navigation = useSectionNavigation()

  const { groupPosition, setGroupPosition, groupsLength, currentFields } =
    navigation

  const filteraction = useSectionFilteraction({ setGroupPosition })

  const { filteractionValue, setFilteractionValue, setChangedKeysData } =
    filteraction

  const composition = useSectionComposition({
    groupsLength,
    setGroupPosition
  })

  const groupActions = useSectionGroupActions({
    groupPosition,
    groupsLength,
    filteractionValue,
    setFilteractionValue,
    setChangedKeysData,
    setGroupPosition
  })

  const { handleClearAll, isEmpty } = groupActions

  const sectionContextValue = useMemo(
    () => ({
      navigation,
      filteraction,
      composition,
      groupActions
    }),
    [navigation, filteraction, composition, groupActions]
  )

  return (
    <SectionContextProvider value={sectionContextValue}>
      <SectionView>
        <FilterActionSetup>
          <FilterButton
            type='submit'
            className='flex-grow-1 flex-md-grow-0 fw-semibold'
            heightClass='regular'
          >
            {t('filter-fields.filter')}
          </FilterButton>
          <FilterButton
            type='button'
            variant='secondary'
            onClick={handleClearAll}
            className='flex-grow-1 flex-md-grow-0 fw-semibold'
            heightClass='regular'
            disabled={isEmpty}
          >
            {t('filter-fields.clean')}
          </FilterButton>
          {shouldRenderFilteractionSelection && <FilteractionSelection />}
          {shouldRenderComposition && <FilterComposition />}
        </FilterActionSetup>
        {shouldRenderFields && (
          <GroupControls>
            <div className='px-3'>
              {currentFields?.length > 0 && <Fields />}
            </div>
          </GroupControls>
        )}
      </SectionView>
    </SectionContextProvider>
  )
}

export default Section
